<template>
	<div id="poster_box">
		<img class="preview_poster" v-if="base64" :src="base64" alt="" />
		<div id="poster" class="guide_order" v-else>
			<div class="guide_order_main">
				<h2 class="title">电子检测指引单</h2>
				<div class="divide"></div>
				<div class="project">
					<h3 class="title">检测项目</h3>
					<div class="list">
						<div
							class="item"
							v-for="item in order.productList"
							:key="item.id"
						>
							<div class="title">{{ item.productName }}</div>
							<div class="detec">
								<p>
									样本类型：{{ getDetectType(item.detectType) }}
								</p>
								<p v-if="item.itemList.length">
									检测项目：{{ item.itemList | getItemName }}
								</p>
							</div>
							<div class="price">￥{{ item.totalPrice }}</div>
						</div>
					</div>
					<div class="total">
						合计：<span class="price">￥{{ order.payPrice }}</span>
					</div>
				</div>
			</div>

			<div class="guide_order_main">
				<div class="cell">
					<div class="label">医生所属医院</div>
					<div class="value">{{ order.doctorHospital }}</div>
				</div>
				<div class="cell">
					<div class="label">医生所属科室</div>
					<div class="value">{{ order.doctorDept }}</div>
				</div>
				<div class="cell">
					<div class="label">医生姓名</div>
					<div class="value">{{ order.doctorName }}</div>
				</div>
			</div>

			<div class="guide_order_main">
				<div class="code">
					<img class="code__inner" :src="order.qrCode" alt="" />
					<p class="code_desc">请在微信里长按图片识别关注</p>
					<p class="code_desc">公众号完成付款</p>
				</div>
			</div>
		</div>
		<van-share-sheet
			v-model="share.visible"
			title="立即分享给好友"
			:options="share.options"
			@select="clickSelectShare"
		/>
		<div class="btn_box">
			<div class="btn" @click="clickSave">点击分享图片</div>
		</div>
	</div>
</template>

<script>
	import html2canvas from 'html2canvas';
	export default {
		data: () => ({
			share: {
				visible: false,
				options: [
					{ name: '保存图片', value: 'saveImg', icon: 'poster' },
				]
			},
			base64: '',
			order: {},
			sampleList: {}
		}),

		created () {
			this.base64 = '';
			this.getSampleList();
			this.load ();
		},
		filters: {
			getItemName (list) {
				return (list || []).map((val) => val.itemName).join("、")
			},
		},

		methods: {
			load () {
				this.$http.get(`${process.env['VUE_APP_SSL_URL']}detect/order/info/${this.$route.params.id}`).then(res => {
					if (!res.code) {
						this.order = res.data;
					}
				})
			},
			getDetectType (val) {
				if (!val) return '';
				return val.split('&').map(item => this.sampleList[item]).join('、');
			},
			getSampleList() {
				this.$api.order.sampleList().then(res=>{
					if (!res.code) {
						res.data.forEach(item => {
							this.sampleList[item.code] = item.name;
						})
					}
				})
			},
			clickSelectShare (val) {
				if (val.value === 'saveImg') {
					const _this = this;
					// eslint-disable-next-line no-undef
					wx.miniProgram.postMessage({
						data: {
							base64: _this.base64
						}
					})
					// eslint-disable-next-line no-undef
					wx.miniProgram.navigateBack();
				}
			},
			clickSave () {
				if (this.base64) {
					this.$set(this.share, 'visible', true);
					return;
				}
				html2canvas(document.getElementById('poster'), {
					useCORS: true,
					allowTaint: true,
				}).then(canvas => {
					const imgData = canvas.toDataURL('image/jpeg', 1.0);
					this.base64 = imgData;
					this.$set(this.share, 'visible', true);
				});
			}
		}
	}
</script>

<style scoped lang="less">
	.preview_poster {
		max-width: 100%;
		vertical-align: middle;
	}
	.guide_order {
		padding: 100px 32px;
		background-image: linear-gradient(180deg, #3F6CDE 5%, #3F6CDE 10%, rgba(63, 108, 222, 0) 100%);
		&_main {
			border-radius: 16px;
			padding: 0 28px;
			background-color: #fff;
			& + .guide_order_main { margin-top: 28px; }
			>.title {
				font-family: PingFangSC-Semibold;
				font-size: 56px;
				font-weight: normal;
				line-height: 67px;
				text-align: center;
				color: #000000;
				padding: 50px 0;
			}

			.divide {
				position: relative;
				height: 1px;
				background-color: #eee;
				&:before,&:after {
					content: '';
					width: 36px;
					height: 36px;
					background-color: #3F6CDE;
					border-radius: 50%;
					position: absolute;
					top: -18px;
				}
				&:before { left: -50px; }
				&:after { right: -50px; }
			}

			.project {
				margin-top: 50px;
				>.title {
					font-family: PingFangSC-Semibold;
					font-size: 36px;
					font-weight: normal;
					line-height: 42px;
					letter-spacing: 0px;
					color: #1F2329;
				}

				.list {
					.item {
						margin-top: 28px;
						padding: 28px 24px;
						border-radius: 14px;
						background-color: #F9FBFD;

						>.title {
							font-family: PingFangSC-Medium;
							font-size: 32px;
							font-weight: normal;
							line-height: 34px;
							letter-spacing: 0px;
							/* 正文色/正文色 */
							color: #1A1A1A;
						}
						.detec {
							margin-top: 22px;
							padding: 16px 28px;
							border-radius: 10px;
							background-color:rgba(61, 122, 235, 0.08);

							font-family: PingFangSC-Medium;
							font-size: 26px;
							font-weight: normal;
							line-height: normal;
							letter-spacing: 0em;

							color: #3D7AEB;

							p + p { margin-top: 12px; }
						}
						.price {

							margin-top: 28px;
							font-family: PingFangSC-Medium;
							font-size: 30px;
							font-weight: normal;
							line-height: 34px;
							letter-spacing: 0px;

							/* 危险/Danger-6 */
							color: #FA5151;

						}
					}
				}
				.total {
					padding: 30px 0;
					text-align: right;
					font-family: PingFangSC-Regular;
					font-size: 28px;
					font-weight: normal;
					line-height: 34px;
					text-align: right;
					letter-spacing: 0px;
					color: #666666;
					.price {
						font-family: PingFangSC-Medium;
						font-size: 30px;
						font-weight: normal;
						line-height: 34px;
						letter-spacing: 0px;

						/* 危险/Danger-6 */
						color: #FA5151;
					}
				}
			}

			.cell {
				display: flex;
				align-items: center;
				justify-content: space-between;
				padding: 34px 0;
				& + .cell { border-top: 1px solid #f5f5f5; }
				.label {

					flex: 0 0 230px;
					font-family: PingFangSC-Medium;
					font-size: 30px;
					font-weight: normal;
					letter-spacing: 0px;

					/* 文字/N-900 */
					color: #1F2329;

				}
				.value {

					font-family: PingFangSC-Regular;
					font-size: 30px;
					font-weight: normal;
					text-align: right;
					letter-spacing: 0px;

					color: #43464D;
				}
			}

			.code {
				text-align: center;
				padding: 50px 0;
				&__inner {
					width: 480px;
					vertical-align: middle;
					margin-bottom: 20px;
				}
				&_desc {

					font-family: PingFangSC-Medium;
					font-size: 32px;
					font-weight: normal;
					line-height: 46px;
					text-align: center;
					letter-spacing: 0em;

					/* 文字/N-900 */
					color: #1F2329;

				}
			}
		}
	}

	.btn_box {
		padding: 0 32px 50px;
		.btn{
			width: 100%;
			height: 100px;
			border-radius: 12px;
			background-color: #3F6CDE;
			text-align: center;
			line-height: 100px;
			font-size: 32px;
			color: #fff;
		}
	}
</style>
